<div class="bg--lightgrey u-pt60">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6 col-md-5 u-mb20">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
            <li>
              <a routerLink="../../">
                Aprobar solicitudes
              </a>
            </li>
          </ul>
        </div>
        <h1 class="txt txt--title">
          <a (click)="goBack()" class="back hover-hand" data-id="tab-three-c">
            Solicitud Nº {{requirementId}}
          </a>
        </h1>
      </div>
      <div class="col-12 col-lg-6 col-md-7 u-mb20 status">
        <p class="txt txt--paragraph">Estado de aprobaciones</p>
        <app-flow-states [id]="requirementId" variant="tiny" [requirementStatus]="flowData"></app-flow-states>
      </div>
    </div>
  </div>
</div>
<div class="u-pt50 u-pb70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-license-detail *ngIf="this.dataRequirement" [requirementId]="requirementId"
          [shouldShowDocumentLinks]="true" [shouldShowPersonalData]="true" [shouldShowFlow]="false"
          [shouldShowRequestNumberTitle]="false" [gettingDataRequirement]="dataRequirementGetting"
          [gettingDataPerson]="personDataGetting" [getDetailsError]="dataRequirementError"
          [getPersonError]="personDataError" [personData]="personData" [equipments]="equipments" [documents]="documents"
          personalDataTitle="1. Información del conductor" equipmentTitle="2. Equipos registrados"
          [shouldEditEffectiveDate]="shouldShowAdditionalInfoForm" [documentTableForm]="documentTableForm"
          [shouldShowMineDocumentTable]="shouldShowMineDocumentTable" [mineDocumentTableForm]="mineDocumentTableForm"
          [assetId]="this.dataRequirement.assetId">
        </app-license-detail>

        <div class="col-12" >
          <div class="textWarningFillDocumentContainer">
            <p class="textWarningFillDocument">
              {{ this.documentTableForm.errors ? this.documentTableForm.errors.description : ' '}}
              &nbsp;
            </p>
          </div>
        </div>

      </div>
      <div class="col-12" *ngIf="shouldShowLicenseLink">
        <div class="col-12">
          <div class="u-mt5 u-mb20 u-bt u-bt--grey"></div> <!-- line divider -->
          <a class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0 "
            (click)="onShowRequestDetail()">
            Ver licencia completa del conductor
            <img class="ml-2 show-license-link-corrected-icon" src="assets/img/arrow_r_g.png" alt="">
          </a>
        </div>
      </div>
      <div class="col-md-12" [ngClass]="{'u-lock': this.documentTableForm.errors }">
        <app-additional-info [ngClass]="{'global-remove': !shouldShowAdditionalInfoForm}"
          [additionalInformationForm]="additionalInfoForm"
          [validityTypes]="validityTypes"
        ></app-additional-info>
      </div>
    </div>
  </div>
</div>

<div class="bg--lightgrey u-pt20 u-pb20" >
  <div class="container" *ngIf="!!dataRequirement">
    <div class="col-12 justify-content-between" *ngIf="selectedAction === ''">
      <button type="button" class="btn btn--primary btn--primary--icon u-mt10 u-mb10 mr-md-2 corrected-icon"
        [ngClass]="{'btn--disabled': !shouldActivateApproveButton}" (click)="selectAction('approve')">
        Aprobar solicitud
      </button>
      <button type="button" class="btn btn--primary btn--primary--icon u-mt10 u-mb10 mr-md-2 corrected-icon"
        (click)="selectAction('request-more-info')">
        Solicitar más antecedentes
      </button>
      <button type="button" class="btn btn--primary btn--primary--icon u-mt10 u-mb10 mr-md-2 corrected-icon"
        (click)="selectAction('delegate')">
        Delegar a otra persona
      </button>
      <button type="button" class="btn btn--primary btn--primary--icon u-mt10 u-mb10 mr-md-2 corrected-icon"
        (click)="selectAction('reject')">
        Rechazar licencia
      </button>
    </div>

    <div class="col-12">
      <app-approve-request
        *ngIf="selectedAction === 'approve'"
        [requirementId]="requirementId"
        [assetId]="dataRequirement?.assetId || 0"
        [selectedPersonEmail]="personData.email"
        [virtualRole]="virtualRole"
        (goBack)="selectAction('')"
        class="row"
      ></app-approve-request>
      <app-request-more-info *ngIf="selectedAction === 'request-more-info'" [requirementId]="requirementId"
        [selectedPersonEmail]="personData.email" [virtualRole]="virtualRole" (goBack)="selectAction('')" class="row">
      </app-request-more-info>
      <app-delegate [requirementId]="requirementId" *ngIf="selectedAction === 'delegate'" (goBack)="selectAction('')"
        class="row"></app-delegate>
      <app-reject *ngIf="selectedAction === 'reject'" [requirementId]="requirementId" [virtualRole]="virtualRole"
        [selectedPersonEmail]="personData.email" (goBack)="selectAction('')" class="row"></app-reject>
    </div>
  </div>
</div>
